const PREFERRED_LANGUAGE_KEY = 'preferredLanguage';
const DEFAULT_MAX_AGE = 10 * 365 * 24 * 60 * 60;
export const SUPPORTED_LANGUAGES = ['en', 'sw', 'so'];
export const DEFAULT_LANGUAGE = 'en';

function isBrowser() {
    return typeof document !== 'undefined';
}

// Theme configuration
export const theme = {
    class: 'theme-',
    // Default light theme
    light: {
        '--bg-primary': '#ffffff',
        '--bg-secondary': '#f9fafb',
        '--text-primary': '#111827',
        '--text-secondary': '#6b7280',
        '--border-color': '#e5e7eb',
        '--accent': '#3b82f6',
    },
    // Dark theme configuration
    dark: {
        '--bg-primary': '#1a1a1a',
        '--bg-secondary': '#2d2d2d',
        '--text-primary': '#f3f4f6',
        '--text-secondary': '#9ca3af',
        '--border-color': '#374151',
        '--accent': '#60a5fa',
    }
};

export function setLanguageCookie(lang, options = {}) {
    if (!isBrowser()) return;

    const { maxAge = DEFAULT_MAX_AGE } = options;
    const value = encodeURIComponent(lang);
    const maxAgeDirective = Number.isFinite(maxAge) ? `;max-age=${maxAge}` : '';

    document.cookie = `${PREFERRED_LANGUAGE_KEY}=${value};path=/${maxAgeDirective}`;

    try {
        window.localStorage.setItem(PREFERRED_LANGUAGE_KEY, lang);
    } catch (_error) {
        // Ignore storage errors; the cookie remains the source of truth.
    }
}

export function getLanguageCookie() {
    if (!isBrowser()) return null;

    const match = document.cookie.match(
        new RegExp(`(?:^|; )${PREFERRED_LANGUAGE_KEY}=([^;]*)`)
    );

    return match ? decodeURIComponent(match[1]) : null;
}

export function getStoredPreferredLanguage() {
    if (!isBrowser()) return null;

    try {
        const stored = window.localStorage.getItem(PREFERRED_LANGUAGE_KEY);
        if (SUPPORTED_LANGUAGES.includes(stored)) {
            return stored;
        }
    } catch (_error) {
        // Fall through to cookie lookup.
    }

    const cookieLanguage = getLanguageCookie();
    return SUPPORTED_LANGUAGES.includes(cookieLanguage) ? cookieLanguage : null;
}

export function resolveLanguageFromPathname(pathname = '') {
    const [ , maybeLang ] = pathname.split('/');
    return SUPPORTED_LANGUAGES.includes(maybeLang) ? maybeLang : null;
}

export function applyThemeToDocument(themeName = 'light') {
    if (!isBrowser()) return;

    const currentTheme = theme[themeName] || theme.light;
    const root = document.documentElement;

    Object.keys(currentTheme).forEach(key => {
        root.style.setProperty(key, currentTheme[key]);
    });
}

export function getCurrentTheme() {
    if (!isBrowser()) return 'light';
    const cookieTheme = getLanguageCookie('theme');
    return cookieTheme === 'dark' ? 'dark' : 'light';
}

export function setThemeCookie(themeName) {
    if (!isBrowser()) return;

    const value = encodeURIComponent(themeName);
    document.cookie = `theme=${value};path=/;max-age=${10 * 365 * 24 * 60 * 60}`;
}